export class AssetFieldModel {

  uid: number;
  name: string;
  value: string;
  binding: string
  error: boolean;
  keyboardType: string;
  
  constructor() {
  }
}